var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routerData)?_c('div',{staticClass:"layout-sider"},[_c('el-menu',{attrs:{"default-active":_vm.fullPath,"unique-opened":"","text-color":"#000","active-text-color":"#1890ff"},on:{"select":_vm.selectMenu}},[_c('menu-item',{attrs:{"data":_vm.routerData,"path":_vm.routerData.path}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }